import React from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";

function WeekIterator({ onPrevious, onNext }) {
  return (
    <div className="inline-flex h-9 rounded-md overflow-hidden -ml-1">
      <button
        onClick={onPrevious}
        className="inline-flex items-center justify-center px-3 h-full text-sm font-normal text-gray-600 dark:text-gray-300 bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-white/[0.06] transition-colors duration-150 rounded-l-md"
      >
        <ChevronLeftIcon className="h-5 w-5" />
      </button>
      <button
        onClick={onNext}
        className="inline-flex items-center justify-center px-3 h-full text-sm font-normal text-gray-600 dark:text-gray-300 bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-white/[0.06] transition-colors duration-150 border-l border-gray-100 dark:border-gray-700"
      >
        <ChevronRightIcon className="h-5 w-5" />
      </button>
    </div>
  );
}

export { WeekIterator };
